import React from 'react';
import './CourseCard.less';

function CourseCard({data: {year, title, description}, index}) {
  return (
    <div className='CourseCard'>
      <div>
        <div>{year}</div>
        <div>
          <i data-first={index === 0 ? true : null} />
          <img src='/imgs/about/circle.png' alt='circle' />
        </div>
        <div>
          <span>{title}</span>
          <span>{description}</span>
        </div>
      </div>
    </div>
  );
}

export default CourseCard;


// WEBPACK FOOTER //
// ./src/routes/About/CourseCard.js